export class Constants {
  static THEME_MODE_DARK = "theme_dark";
  static USER_LOGIN_RESPONSE = 'user_token';
  static USER_ME_RESPONSE = 'user';
}
